module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/cpu-1-b7152d5e1733aee50a28ad3fa59c3809.svg";